import { render, staticRenderFns } from "./TransactionTile.vue?vue&type=template&id=630d27dd&scoped=true&"
import script from "./TransactionTile.vue?vue&type=script&lang=js&"
export * from "./TransactionTile.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTile.vue?vue&type=style&index=0&id=630d27dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d27dd",
  null
  
)

export default component.exports